/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import NotifContent from '../funtComponents/notifContent';
import AppBar from '@mui/material/AppBar';

import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import Button from '@mui/material/Button';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';

import { NavLinks } from '../funtComponents/functElements';
import { connect, useDispatch } from 'react-redux';
import * as redux from '../../redux/constanst/index';
import { llamadasEntrantes, llamadasSalientes, mapStateToProps, llamadasErrores, hosting } from './models/buscar';

import LoadScreen from './loadScreen';

function PrimarySearchAppBar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notif, setNotif] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [user] = React.useState({
    print: true,
    userName: props.token.name,
    userAvatar: true
  });

  const isNotifOpen = Boolean(notif);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [openLoad, setOpenLoad] = React.useState(false);

  const [anexosActualesR, SetAnexosActualesR] = useState(props.rightAnexos);
  const [idBuscarS, setIdBuscarS] = useState(props.idBuscar);

  const handlerSearch = async (diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos) => {
    const errores = llamadasErrores("nada", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
    if ((typeof errores) !== "number") {
      dispatch({ type: redux.USER_ERRORSTATE_STATE_CHANGE, errorState: errores.mensaje })
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true })

    }
    if (errores === 200) {
      setOpenLoad(true);
      const respEntrantes = await llamadasEntrantes("entrantes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      const respSalientes = await llamadasSalientes("salientes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      if (respSalientes?.type === "SQL" || respEntrantes?.type === "SQL") {
        handlerSearch(diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos)
        return
      }
      await dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: respSalientes })

      await dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: respEntrantes })
      setOpenLoad(false);
    }



  }

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  }



  const handleNotifClose = () => {
    setNotif(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const LogOut = () => {


    dispatch({ type: redux.CLEAR_DATA })
    navigate('/');
  }

  const Check = async () => {
   
    const url = `${hosting}/mimegacall/api/tablero.php`
    var formData = new FormData();
    formData.append("userId", props.idBuscar.id);
    const resp = await fetch(`${url}`, {
      headers: {
        'Accept': 'application/json',
      },
      method: "POST",
      body: formData
    }).then(async (data) => {
      const respBody = await data.json();

      dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: Object.values(respBody) })
      dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: [] })
      setIdBuscarS(respBody)
      return respBody


    });
    return resp

  }

  const handleSelected = (item) => {

    dispatch({ type: redux.PESELECT_STATE_CHANGE, preselect: props.token.level !== "admin" })
  }

  useEffect(() => {
    if (JSON.stringify(idBuscarS) !== JSON.stringify(props.idBuscar)) {
      Check()
      setIdBuscarS(props.idBuscar)
    }





  }, [props.idBuscar])

  useEffect(() => {
    if (JSON.stringify(anexosActualesR) !== JSON.stringify(props.rightAnexos)) {
      /* dispatch({ type: USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: [] }) */
      handlerSearch(props.dateChangeInicio.dia, props.dateChangeInicio.mes, props.dateChangeFinal.dia, props.dateChangeFinal.mes, props.dateChangeInicio.year, props.dateChangeFinal.year, Object.values(props.rightAnexos))
      SetAnexosActualesR(props.rightAnexos)
    }






  }, [props.rightAnexos])


  const boxNotifId = 'primary-search-account-menu';
  const renderNotf = (
    <Menu
      notif={notif}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={boxNotifId}
      keepMounted
      transformOrigin={{
        vertical: 'left',
        horizontal: 'left',
      }}
      open={isNotifOpen}
      onClose={handleNotifClose}
    >

      <NotifContent />
    </Menu>
  );

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {props.token.level === "admin" ? <MenuItem >
        <NavLinks to="/AdminEdit" style={{ color: "#000" }}>
          Editar como administrador
        </NavLinks>
      </MenuItem>: null}
      <MenuItem >
        <NavLinks to="/UserPage" style={{ color: "#000" }}>
          Mi perfil
        </NavLinks>
      </MenuItem>
      <MenuItem onClick={LogOut}>Salir</MenuItem>
    </Menu>
  );


  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>

      <AppBar position="static" color='inherit' style={{ backgroundColor: 'rgba(24,27,42,1)' }}>

        <Toolbar>

          <TroubleshootIcon style={{ width: 25, height: 25 }} />
          <Tooltip title="Click aquí para cambiar entre sucursales" followCursor>
            <Button style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', marginLeft: 10, color: 'red' }}
              aria-controls={menuId}
              onClick={() => handleSelected()}><h4 style={{ color: 'white' }}>{props.idBuscar.name}</h4>
            </Button>
          </Tooltip>



          <Box sx={{
            flexGrow: 1, alignItems: 'center', justifyContent: 'flex-end', color: '#000',
            fontWeight: 500, display: 'flex'
          }}>

            <Button color="primary" backgroundColor='rgba(73, 73, 73, 0.3)'
              aria-controls={menuId}
              onClick={handleProfileMenuOpen}>

              {user.print === true ? <h4 style={{ color: 'lightgrey' }}>{user.userName}</h4> : null}


              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                color="inherit"
              >
                {user.print ? <img src={require("../../images/favicon.ico").default} style={{ maxHeight: 20, alignSelf: 'center' }} />
                  : <AccountCircle style={{ color: 'rgba(73, 73, 73, 0.3)' }} />}
              </IconButton>
            </Button>

          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>






            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              aria-controls={boxNotifId}
              aria-haspopup="true"
            >
              <NavLinks to="/Notificacion" style={{ color: "#000" }}>
                <Badge badgeContent={1} color="error">
                  <NotificationsIcon style={{ color: '#f6f6f6' }} />
                </Badge>
              </NavLinks>
            </IconButton>
            {renderNotf}



          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon style={{ color: 'rgba(73, 73, 73, 0.3)' }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad} />

    </Box>
  );
}

export default connect(mapStateToProps, null)(PrimarySearchAppBar)